import { get } from '../../../utils/dot-notation';

function Locale (language) {
  return Object.assign(Object.create(Locale), language);
};

Locale.lang = function (key, fallback = null) {
  return get(this, key, fallback || `{{${key}}}`);
};

export default Locale;
